import * as React from 'react';
import SvgIcon, { SvgIconProps } from '../SvgIcon';
import { default as SnacksIconSrc } from '../assets/snacks-icon.svg';

export const SnacksIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <SnacksIconSrc />
  </SvgIcon>
);